import { Avatar, Box, Card, CardContent, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid2, IconButton, InputLabel, MenuItem, Pagination, Paper, Select, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from "@mui/material"
import Dropdown from "../../reusable_components/components/Dropdown"
import '../jobPostings/jobpostings.css';
import { useAddJobPostingsMutation, useAssignRecruiterMutation, useBindingEditJobPostingMutation, useGetClientDropdownQuery, useGetCoordinatorDropdownQuery, useGetJobPostingsTableDatasMutation, useRecruiterListMutation, useReferralJobListMutation, useSaveDuplicateMutation, useSelectRecruiterListMutation } from "../../redux/jobpostings/jobpostings.api";
import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MUIButton from "../../reusable_components/components/MUIButton";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import { useSelector } from "react-redux";
import { SnackbarContext } from "../../reusable_components/components/Snackbar";
import { TableLoader } from "../../reusable_components/components/TableLoader";
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DoneIcon from '@mui/icons-material/Done';
import DownloadIcon from "../../assets/Icons/DownloadIcon";
import SearchIconLg from "../../assets/Icons/SearchIcon";
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { useGetReferalTableListMutation } from "../../redux/clientReferences/clientReferences.api";
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import { useJobReferralPaymentsListMutation } from "../../redux/ReferralPayment/ReferralPayments.api";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ClearIcon from '@mui/icons-material/Clear';

const JobReferralPayment = () => {

    const [open, setOpen] = useState(false)
    const [filterDialogOpen, setFilterDialogOpen] = useState(false)
    const [dialogId, setDialogId] = useState("")
    const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false)
    const [dupPositionId, setDupPositionId] = useState("")
    const [rowDatas, setRowDatas] = useState({})
    const { Profile } = useSelector((state) => state.common)
    const { Snackbar } = useContext(SnackbarContext)
    const [showClearFilter, setShowClearFilter] = useState(false)
    const [openSelectStatus,setOpenSelectStatus] = useState(false)

    const handleOpen = (item) => {
        setOpen(true)
        setDialogId(item?.positionId)
        setRowDatas(item)
    }

    const handleClose = () => {
        setOpen(false)
        setRecruiterCheckbox([])
    }

    const handleFilterDialogOpen = () => {
        setFilterDialogOpen(true)
    }

    const handleFilterDialogClose = () => {
        setFilterDialogOpen(false)
    }

    const handleDuplicateDialogClose = () => {
        setDuplicateDialogOpen(false)
    }

    const [positionId, setPositionId] = useState("")
    const [selectedPositionType, setSelectedPositionType] = useState("")
    const [keywords, setKeywords] = useState("")
    const [clientDropdownDatas, setClientDropdownDatas] = useState([])
    const [selectedClient, setSelectedClient] = useState("")
    const [selectedPriority, setSelectedPriority] = useState("")
    const [location, setLocation] = useState("")
    const [coordinatorDropdownDatas, setCoordinatorDropdownDatas] = useState([])
    const [selectedCoordinator, setSelectedCoordinator] = useState("")
    const [selectedStatus, setSelectedStatus] = useState("")
    const [jobPostingTableDatas, setJobPostingTableDatas] = useState([])
    const [recruitersNames, setRecruiterNames] = useState([])
    const [recruiterCheckbox, setRecruiterCheckbox] = useState([])
    const [showTableLoader, setShowTableLoader] = useState(false)
    const [selectedClientName, setSelectedClientName] = useState("")
    const [selectedCoordinatorName, setSelectedCoordinatorName] = useState("")
    const [searchRecruiter, setSearchRecruiter] = useState("")
    const [searchKeyword, setSearchKeyword] = useState("")
    const [triggerApi, setTriggerApi] = useState(false)

    // Pagination
    const [page, setPage] = useState(1)
    const [totalDataCount, setTotalDataCount] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)

    const navigate = useNavigate()

    const [getTableDatas] = useJobReferralPaymentsListMutation()
    const { data: getClientDropdown } = useGetClientDropdownQuery()
    const { data: getCoordinatordropdown } = useGetCoordinatorDropdownQuery()
    const [recruiterList] = useRecruiterListMutation()
    const [selectRecruiterList, { isLoading: recruiterListLoader }] = useSelectRecruiterListMutation()
    const [assignRecruiter] = useAssignRecruiterMutation()
    const [saveDuplicate, { data: duplicateRow }] = useSaveDuplicateMutation()
    const [addJobPostings] = useAddJobPostingsMutation()

    // Dropdown Api's 
    useEffect(() => {
        localStorage.setItem('activeTab', 1)
        if (getClientDropdown) {
            setClientDropdownDatas(getClientDropdown?.response?.clientList)
        }

        if (getCoordinatordropdown) {
            setCoordinatorDropdownDatas(getCoordinatordropdown?.response?.coordinatorList)
        }
    }, [getClientDropdown, getCoordinatordropdown])

    // Table Datas api
    const getGridDatas = async () => {
        try {

            const params = {
                sortingDirection: "DESC",
                page: page - 1,
                size: rowsPerPage,
                // jobDesc:"",
                // createdBY :"",
                // rewardType :"",
                // positionDesc :"",
            }

            setShowTableLoader(true)
            const response = await getTableDatas(params).unwrap()
            setShowTableLoader(false)
            if (response) {
                const datas = response?.response ? response?.response?.data : []
                setJobPostingTableDatas(datas)
                setTotalDataCount(response?.response?.totalRecords)
            }

        } catch (err) {
            Snackbar("Network Error", 'error')
            setShowTableLoader(false)
        }
    }

    useEffect(() => {
        getGridDatas()

    }, [])

    useEffect(() => {
        if (triggerApi) {
            getGridDatas()
            handleFilterDialogClose()
            setTriggerApi(false)
        }
    }, [getTableDatas, selectedClient, selectedCoordinator, keywords, location, positionId, selectedPositionType, selectedPriority, selectedStatus, rowsPerPage, page, duplicateRow, triggerApi])


    useEffect(() => {
        const getRecruitersDialog = async () => {
            try {
                const payload = {
                    positionId: dialogId
                }

                if (open) {
                    const response = await selectRecruiterList(payload).unwrap()
                    setRecruiterNames(response && response?.response || [])
                    setRecruiterCheckbox(response?.response?.filter((item) => item?.hasSelected)?.map((item) => item?.recruiterId))
                } else {
                    setRecruiterNames([])
                }
            } catch (err) {
                // alert('Network error')
            }
        }
        getRecruitersDialog()
    }, [open])

    const filteredRecruiterLists = recruitersNames?.filter((name) => {
        return (
            (name?.recruiterName?.toLowerCase()?.startsWith(searchRecruiter?.toLowerCase()))
        )
    })

    const handleSearchRecruiterChange = (e) => {
        const value = e.target.value
        setSearchRecruiter(value)
    }

    const handleAssignRecruiterCheckbox = (recruiterId) => {
        setRecruiterCheckbox((prev) => (
            prev?.includes(recruiterId)
                ? prev?.filter((id) => id !== recruiterId)
                : [...prev, recruiterId]
        ))
    }

    const handleAssignRecruiter = async () => {
        try {
            const payload = {
                // PositionId: 17,
                PositionId: dialogId,
                recruiter: recruiterCheckbox,
                recruiterREE: recruiterCheckbox
            }

            const response = await assignRecruiter(payload).unwrap()
            if (response?.status === 200) {
                Snackbar("The job posting has been assigned successfully", 'success')
                setRecruiterCheckbox([])
                handleClose()
            }
        } catch (err) {
            Snackbar('Network error', 'error')
        }
    }

    useEffect(() => {
        const getRecruiterList = async () => {
            try {
                const payload = {
                    keyWords: "",
                    page: 0,
                    size: 10,
                    type: ""
                }

                await recruiterList(payload).unwrap()
            } catch (err) {
                Snackbar('Network error', 'error')
            }
        }
        getRecruiterList()
    }, [recruiterList])

    const handlePositionIdChange = (e) => {
        const value = e.target.value
        setPositionId(value);
    }

    const handlePositionTypeChange = (e) => {
        const value = e.target.value
        setSelectedPositionType(value)
    }

    const handleKeywordChange = (e) => {
        const value = e.target.value
        setKeywords(value)
    }

    const handleClientDropdownChange = (value) => {
        const data = value.toString()
        setSelectedClient(data)

        const name = getClientDropdown?.response?.clientList?.find((id) => id?.clientId === value)
        setSelectedClientName(name?.clientName)
    }

    const handlePriorityChange = (e) => {
        const value = e.target.value
        setSelectedPriority(value)
    }

    const handleLocationChange = (e) => {
        const value = e.target.value
        setLocation(value)
    }

    const handleCoordinatorchange = (value) => {
        setSelectedCoordinator(value)

        const name = getCoordinatordropdown?.response?.coordinatorList?.find((id) => id?.coordinatorId === value)
        setSelectedCoordinatorName(name?.coordinatorName)
    }

    const handleStatusChange = (e) => {
        const value = e.target.value
        setSelectedStatus(value)
    }

    const handleEditScreenNav = (item) => {
        if (Profile?.profile?.role === 'admin' || Profile?.profile?.role === 'coordinator') {
            const id = item?.positionId
            navigate(`/jobpostedit/${id}`)
        }
    }

    // Pagination Functionalities
    const handleChangePage = (e, newPage) => {
        setPage(newPage)
        setTriggerApi(true)
    }

    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
    }

    const handleSearchKeywordChange = (e) => {
        const value = e.target.value
        setSearchKeyword(value)
    }


    const handleProfileNav = (item) => {
        navigate(`/findprofile/${item?.positionId}`, {
            state: { positionId: item?.positionId, clientName: item?.clientName, positionTitle: item?.positionTitle }
        })
    }

    const handleManageEventsNav = (item) => {
        navigate(`/manage-events/${item?.positionId}`, {
            state: { positionId: item?.positionId, clientName: item?.clientName, positionTitle: item?.positionTitle }
        })
    }

    const handleProfileSubmissionNav = (item) => {
        navigate(`/referrals/submitprofiles/${item?.positionId}`, {
            state: { position: item?.positionTitle, name: item?.clientName, isReferrals: true }
        }
        );
    }

    const handleNavViewPayments = (item) => {
        navigate('/view-job-payments', {
            state: {
                positionName: item?.positionName, recruiterId: item?.recruiterId, recruitersName: item?.recruiterName, recruiterEmail: item?.recruiterEmail, positionId: item?.positionId, clientId: item?.clientId, clientName: item?.clientName
            }
        })
    }

    const [jobId, setJobId] = useState(null)

    const handleAddJobDialogOpen = (item) => {
        setDuplicateDialogOpen(true)
        setJobId(item?.positionId)
    }

    const handlPostjob = async () => {
        try {
            const payload = {
                positionId: jobId,
            }
            const response = await addJobPostings(payload).unwrap()

            if (response?.status === 200) {
                Snackbar("Job Added Suceessfully", 'success')
                setDuplicateDialogOpen(false)
                getGridDatas()
            }

        } catch (error) {
            Snackbar("Network error", 'error')
        }

    }

    const [chips, setChips] = useState([])

    const letsFilterDatas = () => {

        const updateChip = ([
            {
                label: keywords,
                onDelete: () => {
                    setKeywords('')
                    setTriggerApi(true)
                    setChips(prevChip => prevChip.filter(chips => chips.label !== keywords))
                }
            },
            {
                label: positionId,
                onDelete: () => {
                    setPositionId('')
                    setTriggerApi(true)
                    setChips(prevChip => prevChip.filter(chips => chips.label !== positionId))
                }
            },
            {
                label: selectedClientName,
                onDelete: () => {
                    setSelectedClientName('')
                    setSelectedClient('')
                    setTriggerApi(true)
                    setChips(prevChip => prevChip.filter(chips => chips.label !== selectedClientName))

                }
            },
            {
                label: selectedPositionType,
                onDelete: () => {
                    setSelectedPositionType('')
                    setTriggerApi(true)
                    setChips(prevChip => prevChip.filter(chips => chips.label !== selectedPositionType))

                }
            },
            {
                label: selectedPriority,
                onDelete: () => {
                    setSelectedPriority('')
                    setTriggerApi(true)
                    setChips(prevChip => prevChip.filter(chips => chips.label !== selectedPriority))

                }
            },
            {
                label: selectedCoordinatorName,
                onDelete: () => {
                    setSelectedCoordinatorName('')
                    setSelectedCoordinator('')
                    setTriggerApi(true)
                    setChips(prevChip => prevChip.filter(chips => chips.label !== selectedCoordinatorName))

                }
            },
            {
                label: selectedStatus,
                onDelete: () => {
                    setSelectedStatus('')
                    setTriggerApi(true)
                    setChips(prevChip => prevChip.filter(chips => chips.label !== selectedStatus))

                }
            },
            {
                label: location,
                onDelete: () => {
                    setLocation('')
                    setTriggerApi(true)
                    setChips(prevChip => prevChip.filter(chips => chips.label !== location))

                }
            }
        ])

        setChips(updateChip)
        setShowClearFilter(true)
        setTriggerApi(true)
    }

    useEffect(() => {
        if (chips?.every((name) => !name?.label)) {
            setShowClearFilter(false)
        }
    }, [triggerApi])

    const handleMoreFiltersDelete = () => {
        setPositionId("")
        setSelectedClientName('')
        setSelectedClient('')
        setSelectedPositionType('')
        setSelectedPriority('')
        setSelectedCoordinatorName('')
        setSelectedCoordinator('')
        setSelectedStatus('')
        setKeywords("")
        setLocation("")
        setTriggerApi(true)
        setShowClearFilter(false)
    }

    const filteredTableDatas = jobPostingTableDatas?.filter((item) => {
        return (
            (item?.clientName?.trim()?.toLowerCase()?.startsWith(searchKeyword?.toLowerCase())) ||
            (item?.positionTitle?.toLowerCase()?.startsWith(searchKeyword?.toLowerCase()))
        )
    })

    const priorityOptions = [
        {
            id: "High",
            label: "High"
        },
        {
            id: "Medium",
            label: "Medium"
        },
        {
            id: "Low",
            label: "Low"
        },
    ]

    const positionTypeOptions = [
        {
            id: 'Permanent',
            label: 'Permanent'
        },
        {
            id: 'Contract',
            label: 'Contract'
        },
        {
            id: 'Contract-to-Hire',
            label: 'Contract-to-Hire'
        },
        {
            id: 'Gig Worker',
            label: 'Gig Worker'
        },
    ]

    const statusOptions = [
        {
            id: 'Active',
            label: 'Active'
        },
        {
            id: 'Cancelled',
            label: 'Cancelled'
        },
        {
            id: 'Fulfilled',
            label: 'Fulfilled'
        },
        {
            id: 'Closed',
            label: 'Closed'
        },
        {
            id: 'Hold by client',
            label: 'Hold by client'
        },
        {
            id: 'Dropped by 3E',
            label: 'Dropped by 3E'
        }
    ]

    return (
        <Box >

            {/* Container 3 for Table */}
            <Grid2 item sx={{ marginTop: "20px" }}>
                <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB' }} elevation={0}>
                    <Table>
                        <TableHead style={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 10,
                            width: '100%',
                        }}>
                            <TableRow sx={{
                                '& .MuiTableCell-root': {
                                    borderBottom: 'none', // Change to the desired border style
                                }
                            }}>
                                <TableCell colSpan={100} sx={{ padding: '5px' }}>
                                    {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div>
                                            {showClearFilter && (
                                                chips?.map((item, index) => (
                                                    item?.label && (
                                                        <Chip
                                                            key={index}
                                                            label={item?.label}
                                                            size="small"
                                                            variant="outlined"
                                                            onDelete={item?.onDelete}
                                                            className="Chip"
                                                            deleteIcon={<CloseIcon sx={{ color: '#414651 !important' }} />}
                                                        />
                                                    )
                                                ))
                                            )}
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '14px' }}>
                                            <MUICancelButton title='More Filters' onClick={handleFilterDialogOpen} startIcon={<FilterListIcon sx={{ fontSize: '20px !important' }} />} sx={{ color: '#6941C6', borderColor: '#D6BBFB', fontWeight: 600, width: '130px' }} />
                                            {(keywords || positionId || selectedClient || selectedPositionType || selectedCoordinator || selectedStatus || selectedPriority || location) && showClearFilter && (
                                                <MUICancelButton title='Clear Filter' sx={{ width: '100px' }} onClick={handleMoreFiltersDelete} />
                                            )}
                                        </div>
                                    </div> */}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className="tableHeadersCell" >Business Associate </TableCell>
                                <TableCell className="tableHeadersCell">Referral Job</TableCell>
                                <TableCell className="tableHeadersCell" align="left">Fulfilled Status</TableCell>
                                <TableCell className="tableHeadersCell">Reward Type</TableCell>
                                <TableCell className="tableHeadersCell">Rewards</TableCell>
                                <TableCell className="tableHeadersCell"> Total Earnings</TableCell>
                                <TableCell className="tableHeadersCell" align='left'>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        {!showTableLoader ? (
                            jobPostingTableDatas?.length > 0 ? (
                                jobPostingTableDatas?.map?.((item) =>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell className='tableBodyCell' ><span style={{ color: '#53389E', fontWeight: 'bold' }}>{item?.recruiterId} {item?.recruiterName}</span>
                                                <br></br>{item?.recruiterEmail}</TableCell>
                                            <TableCell className='tableBodyCell'><span style={{ color: '#53389E', fontWeight: 'bold' }}>{item?.positionName}</span><br></br>{item?.clientId} {item?.clientName}</TableCell>
                                            {/* <TableCell className='tableBodyCell' ><sup style={{fontSize:'14px'}}>{item?.jointCount}</sup>/<sub style={{fontSize:'14px'}}>{item?.noOfPosition}</sub></TableCell> */}
                                            <TableCell className='tableBodyCell' >{item?.jointCount}/{item?.noOfPosition}</TableCell>
                                            <TableCell className='tableBodyCell'>{item?.rewardType === "FC" ? "Fixed Amount" : "Fixed Percentage"}<br></br>
                                            </TableCell>
                                            <TableCell className='tableBodyCell'>
                                                {item?.rewardType === "FC"
                                                    ? <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                        <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                        <Typography sx={{ fontSize: '12.5px' }}>
                                                            {item?.rewardAmount}
                                                        </Typography>
                                                    </Box>
                                                    : item?.rewardPercentage != null
                                                        ? <span style={{ marginLeft: '14px' }}>{item?.rewardPercentage}%</span>
                                                        : '-'
                                                }
                                            </TableCell>
                                            <TableCell className='tableBodyCell'>
                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                    <CurrencyRupeeIcon sx={{ fontSize: '14px', color: '#a6aba5' }} />
                                                    <Typography sx={{ fontSize: '12.5px' }}>
                                                        {item?.totalAmount}
                                                    </Typography>
                                                </Box>

                                            </TableCell>
                                            <TableCell className='tableBodyCell' onClick={() => handleNavViewPayments(item)} sx={{ color: '#6941C6', fontWeight: 'bold', cursor: 'pointer' }}>View</TableCell>
                                        </TableRow>
                                    </TableBody>
                                )
                            ) : (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={8}>
                                            <Typography className="emptydatas">No Data Found</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )
                        ) : (
                            <TableRow>
                                <TableCell colSpan={8}>
                                    <Box className='tableloader'>
                                        <TableLoader />
                                    </Box>
                                </TableCell>
                            </TableRow>
                        )}
                        {Math.ceil(totalDataCount / rowsPerPage) > 1 && (
                            <TableRow>
                                <TableCell colSpan={100}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <MUICancelButton
                                            title='Previous'
                                            startIcon={<ArrowBackIcon sx={{ color: page === 1 ? '#a2a2a2' : '#414651' }} />}
                                            onClick={() => handleChangePage(null, page - 1)}
                                            disabled={page === 1}
                                            sx={{ height: '36px' }}
                                        />

                                        <Pagination
                                            page={page}
                                            onChange={handleChangePage}
                                            count={Math.ceil(totalDataCount / rowsPerPage)}
                                            siblingCount={1}
                                            boundaryCount={1}
                                            shape="rounded"
                                            hidePrevButton
                                            hideNextButton
                                        />

                                        <MUICancelButton
                                            title='Next'
                                            startIcon={<ArrowForwardIcon sx={{ color: page === Math.ceil(totalDataCount / rowsPerPage) ? '#a2a2a2' : '#414651' }} />}
                                            onClick={() => handleChangePage(null, page + 1)}
                                            disabled={page === Math.ceil(totalDataCount / rowsPerPage)}
                                            sx={{ height: '36px' }}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        )}
                    </Table>
                </Paper>

                {/* <Table>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    className="tablepagination"
                                    count={totalDataCount || 0}
                                    onPageChange={handleChangePage}
                                    page={page}
                                    rowsPerPage={rowsPerPage}
                                    rowsPerPageOptions={[10, 20, 50]}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table> */}

                {/* Dialog to show more filters */}
                <Grid2 item>
                    <Dialog
                        open={filterDialogOpen}
                        scroll="paper"
                        maxWidth='md'
                        className="sidePopup"
                    >
                        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '18px', fontWeight: 'bold' }}>
                            Filters
                            <CloseIcon sx={{ color: '#717680', cursor: 'pointer' }} onClick={handleFilterDialogClose} />
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <Grid2 container sx={{ display: 'flex', flexDirection: 'column' }}>
                                    {/* Container 1 */}
                                    <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%' }} gap={2}>
                                        <Grid2 item>
                                            <InputLabel className="input"> Keywords </InputLabel>
                                            <TextField
                                                className="textfields"
                                                size="small"
                                                placeholder="Enter the Keyword"
                                                value={keywords}
                                                onChange={handleKeywordChange}
                                            />
                                        </Grid2>

                                        <Grid2 item>
                                            <InputLabel className="input"> Position Id </InputLabel>
                                            <TextField
                                                className="textfields"
                                                size="small"
                                                placeholder="Enter Position Id"
                                                value={positionId || ""}
                                                onChange={handlePositionIdChange}
                                            />
                                        </Grid2>

                                        <Grid2 item>
                                            <InputLabel className="input"> Client </InputLabel>
                                            <Dropdown
                                                className="dropdown"
                                                placeholder="Select Client"
                                                value={selectedClient || ""}
                                                options={clientDropdownDatas || []}
                                                onChange={(value) => handleClientDropdownChange(value)}
                                                valueKey="clientId"
                                                labelKey="clientName"
                                            />
                                        </Grid2>

                                        <Grid2 item>
                                            <InputLabel className="input"> Position Type </InputLabel>
                                            <Select
                                                className="dropdown"
                                                displayEmpty
                                                value={selectedPositionType || ""}
                                                onChange={handlePositionTypeChange}
                                                IconComponent={KeyboardArrowDownIcon}
                                                open={openSelectStatus}
                                                onOpen={() => setOpenSelectStatus(true)}
                                                onClose={() => setOpenSelectStatus(false)}
                                                renderValue={(selected) => {
                                                    if (!selected) {
                                                        return <p className="menuItemsPlaceholder">Select Position Type</p>
                                                    } else {
                                                        const selectedItem = positionTypeOptions?.find((name) => name?.label === selected)
                                                        return selectedItem ? selectedItem?.label : ''
                                                    }
                                                }}
                                            >
                                                <Box className="selectClearButton">
                                                    <MenuItem value="" disabled> <span className="menuItemsPlaceholder"> Select Position Type </span></MenuItem>
                                                    <Tooltip
                                                        title={"Close"}
                                                        arrow
                                                    >
                                                        <IconButton size="small" onClick={() => {
                                                            setOpenSelectStatus(false);
                                                        }}>
                                                            <ClearIcon sx={{ fontSize: '18px', color: '#a2a2a2' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                                {positionTypeOptions?.map((option) => (
                                                    <MenuItem key={option?.id} value={option?.label} className="menuitems">
                                                        {option?.label}
                                                        {option?.label === selectedPositionType && (
                                                            <DoneIcon className="doneIcon" />
                                                        )}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Grid2>
                                    </Grid2>

                                    {/* container 2 */}
                                    <Grid2 item container sx={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '15px' }} gap={2}>
                                        <Grid2 item sx={{ width: '100%' }}>
                                            <InputLabel className="input"> Co-ordinator </InputLabel>
                                            <Dropdown
                                                className="dropdown"
                                                placeholder="Select Co-ordinator"
                                                value={selectedCoordinator || ""}
                                                options={coordinatorDropdownDatas || []}
                                                onChange={(value) => handleCoordinatorchange(value)}
                                                valueKey="coordinatorId"
                                                labelKey="label"
                                            />
                                        </Grid2>

                                        <Grid2 item>
                                            <InputLabel className="input"> Status </InputLabel>
                                            <Select
                                                className="dropdown"
                                                displayEmpty
                                                value={selectedStatus || ""}
                                                onChange={handleStatusChange}
                                                IconComponent={KeyboardArrowDownIcon}
                                                renderValue={(selected) =>
                                                    !selected
                                                        ? <p className="menuItemsPlaceholder">Select Status</p>
                                                        : statusOptions?.find((name) => name?.label === selected)?.label || ''
                                                }
                                            >
                                                <MenuItem value="" disabled> <span className="menuItemsPlaceholder"> Select Status </span></MenuItem>
                                                {statusOptions?.map((option) => (
                                                    <MenuItem className="menuitems" key={option?.id} value={option?.label}>
                                                        {option?.label}
                                                        {option?.label === selectedStatus && (
                                                            <DoneIcon className="doneIcon" />
                                                        )}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </Grid2>

                                        <Grid2 item>
                                            <InputLabel className="input"> Priority </InputLabel>
                                            <Select
                                                className="dropdown"
                                                displayEmpty
                                                value={selectedPriority || ""}
                                                onChange={handlePriorityChange}
                                                IconComponent={KeyboardArrowDownIcon}
                                                sx={{ borderRadius: '10px' }}
                                                renderValue={(selected) =>
                                                    !selected
                                                        ? <span className="menuItemsPlaceholder"> Select Priority</span>
                                                        : priorityOptions?.find((opt) => opt?.label === selected)?.label || ''
                                                }
                                            >
                                                <MenuItem value="" disabled> <span className="menuItemsPlaceholder"> Select Priority </span></MenuItem>
                                                {priorityOptions?.map((option) => {
                                                    return (
                                                        <MenuItem className="menuitems"
                                                            key={option?.id}
                                                            value={option?.label}
                                                            sx={{ display: 'flex', justifyContent: 'space-between', margin: '5px' }}
                                                        >
                                                            {option?.label}
                                                            {option?.label === selectedPriority && (
                                                                <DoneIcon sx={{ fontSize: '18px', color: '#7F56D9' }} />
                                                            )}
                                                        </MenuItem>
                                                    )
                                                })}

                                            </Select>
                                        </Grid2>

                                        <Grid2 item>
                                            <InputLabel className="input"> Location </InputLabel>
                                            <TextField
                                                className="textfields"
                                                size="small"
                                                placeholder="Enter Location"
                                                value={location}
                                                onChange={handleLocationChange}
                                            />
                                        </Grid2>
                                    </Grid2>
                                </Grid2>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Grid2 item sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <MUICancelButton title='Cancel' onClick={handleFilterDialogClose} sx={{ width: '42%' }} />
                                <MUIButton
                                    sx={{ width: '42%' }}
                                    title='Apply'
                                    onClick={letsFilterDatas}
                                />
                            </Grid2>
                        </DialogActions>
                    </Dialog>
                </Grid2>

                {/* Dialog to show Duplicate */}
                <Grid2 item>
                    <Dialog
                        open={duplicateDialogOpen}
                        onClose={handleDuplicateDialogClose}
                        scroll="paper"
                        maxWidth="xs"
                        sx={{
                            "& .MuiDialog-paper": {
                                width: '90%',
                                maxWidth: '500px',
                                height: 'auto',
                                borderRadius: '15px',
                                padding: '3px'
                            },
                        }}
                    >
                        <DialogContent>
                            <DialogContentText>
                                <div style={{ display: 'flex', gap: '12px', marginTop: '9px' }}>
                                    <div style={{ backgroundColor: '#E6E6FA', borderRadius: '40px', height: '50px', width: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <PostAddOutlinedIcon sx={{ color: '#7F56D9' }} />
                                    </div>
                                    <div>
                                        <Typography sx={{ color: '#181D27', fontWeight: 600, fontSize: '17px' }}>Add Job Postings?</Typography>
                                        <Typography sx={{ color: '#535862', fontWeight: 400, fontSize: '14px' }}>
                                            Are you sure you want to add this Job ?
                                        </Typography>
                                    </div>
                                </div>
                            </DialogContentText>
                            <Grid2 item sx={{ marginTop: '25px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <MUICancelButton title='No' onClick={handleDuplicateDialogClose} />
                                <MUIButton title='Yes' onClick={handlPostjob} sx={{ backgroundColor: '#7F56D9', borderRadius: '10px' }} />
                            </Grid2>
                        </DialogContent>
                    </Dialog>
                </Grid2>

                {/* Dialog to show recruiters */}
                <Grid2 item>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        scroll='paper'
                        maxWidth='md'
                        className="sidePopup"
                    >
                        <DialogContent>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <Typography sx={{ color: '#000000', fontWeight: 600, fontSize: '16px' }}>Assign Recruiters</Typography>
                                <Typography sx={{ color: '#6941C6', fontWeight: 600, fontSize: '14px', marginTop: '5px' }}>{rowDatas?.positionTitle} | {rowDatas?.clientName}</Typography>

                                <TextField
                                    size="small"
                                    placeholder="Search"
                                    className="textfields"
                                    slotProps={{
                                        input: {
                                            startAdornment: <SearchIconLg style={{ paddingRight: '5px' }} />
                                        },
                                    }}
                                    value={searchRecruiter}
                                    onChange={handleSearchRecruiterChange}
                                    sx={{
                                        marginTop: '25px',
                                        '& .MuiOutlinedInput-root': {
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#9E77ED',
                                            },
                                        },
                                    }}
                                />

                                {!recruiterListLoader ? (
                                    filteredRecruiterLists?.length > 0 ? (
                                        filteredRecruiterLists?.map((item, index) => {
                                            const firstLetter = item?.recruiterName
                                            const letter = firstLetter?.charAt(0)?.toUpperCase()
                                            const colors = ['green', "darkorange", 'purple', "#3357FF", 'orangered', "darkgreen", 'pink']
                                            const backgroundColor = colors[index % colors?.length]
                                            return (
                                                <DialogContentText
                                                    sx={{
                                                        width: '100%',
                                                        fontSize: '13.5px',
                                                        color: "#000000",
                                                        alignItems: 'center',
                                                        display: 'flex',
                                                    }}
                                                >
                                                    <Grid2 container sx={{ width: '100%', marginTop: '15px' }}>
                                                        <Card className='recruitercard'
                                                            elevation={0}
                                                            key={item?.recruiterId}
                                                            onClick={() => handleAssignRecruiterCheckbox(item?.recruiterId)}
                                                            sx={{
                                                                border: recruiterCheckbox?.includes(item?.recruiterId) && '1px solid #9E77ED', '& .MuiCardContent-root': {
                                                                    padding: '12px'
                                                                }
                                                            }}
                                                        >
                                                            <CardContent>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                    <Box sx={{ display: 'flex', gap: '10px' }}>
                                                                        <Avatar sx={{ backgroundColor: backgroundColor }}>{letter}</Avatar>
                                                                        <div>
                                                                            <Typography sx={{ color: '#181D27', fontSize: '14px', fontWeight: 600 }}>{item?.recruiterName}</Typography>
                                                                            <Typography sx={{ color: '#717680', fontSize: '10px' }}>{item?.recruiterCompanyName}</Typography>
                                                                        </div>
                                                                    </Box>
                                                                    {recruiterCheckbox?.includes(item?.recruiterId) && (
                                                                        <div>
                                                                            <CheckCircleOutlinedIcon sx={{ fontSize: '17px', color: '#32CD32' }} />
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                <Grid2 sx={{ marginTop: '10px' }}>
                                                                    <Typography sx={{ color: '#535862', fontSize: '12px' }}>Email</Typography>
                                                                    <Typography sx={{ color: '#6941C6', fontWeight: 600, fontSize: '13px', alignItems: 'center', display: 'flex' }}>{item?.recruiterEmailId} <ArrowOutwardIcon sx={{ fontSize: '16px' }} /> </Typography>
                                                                </Grid2>

                                                                <Grid2 sx={{ marginTop: '10px' }}>
                                                                    <Typography sx={{ color: '#535862', fontSize: '12px' }}>Phone</Typography>
                                                                    <Typography sx={{ color: '#6941C6', fontWeight: 600, fontSize: '13px', alignItems: 'center', display: 'flex' }}>{item?.recruiterPhone}<ArrowOutwardIcon sx={{ fontSize: '16px' }} /> </Typography>
                                                                </Grid2>
                                                            </CardContent>
                                                        </Card>
                                                    </Grid2>
                                                </DialogContentText>
                                            )
                                        })
                                    ) : (
                                        <DialogContentText sx={{ width: '100%' }}>
                                            <Typography className="emptydatas">No Data Found</Typography>
                                        </DialogContentText>
                                    )
                                ) : (
                                    <Box className='tableloader'>
                                        <TableLoader />
                                    </Box>
                                )}
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Grid2 item sx={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                <MUICancelButton title='Cancel' onClick={handleClose} sx={{ width: '42%' }} />
                                <MUIButton title='Assign' onClick={handleAssignRecruiter} sx={{ width: '42%' }} />
                            </Grid2>
                        </DialogActions>
                    </Dialog>
                </Grid2>
            </Grid2 >
        </Box >
    )
}

export default JobReferralPayment